import React, { useState } from "react";
import { useSelector } from "react-redux";
import { darkTheme, lightTheme } from "../../../../theme/Theme";
import { Box, Typography, useMediaQuery } from "@mui/material";
import CommonLayout from "../CommonComponent/CommonLayout";
import CustomSearch from "../../../../utils/CustomSearch/CustomSearch";
import {
  commonButtonStyle,
  commonTextStyle,
} from "../../../PotatoProtection/LargeScreen/Landing/potatoprotectstyle";
import { Button } from "pepsico-ds";
import AppTable from "./AppTable";
import AdminAppModal from "./AdminAppChild/AdminAppModal";
export default function AdminApp() {
  const isDarkTheme = useSelector((state) => state.theme);
  const isMobile = useMediaQuery("(max-width:600px)");
  const isMedium = useMediaQuery("(max-width:850px)");
  const [searchText, setSearchText] = useState("");
  const [open, setOpen] = useState(false);
  const { mobileLoading } = useSelector((store) => store.appadmin);
  const handleSearch = (value) => {
    setSearchText(value);
  };
  const handleOpenModal = () => {
    setOpen(true);
  };
 
  // if (mobileLoading) return <Loading />;
  return (
    <CommonLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          background: isDarkTheme
            ? darkTheme.backgroundColorLayer1
            : lightTheme.backgroundColorLayer2,
        }}
        data-testid="access-history"
      >
        <Box
          sx={{
            display: "flex",
            padding: "var(--Spacing-spacing-8, 8px)",
            alignItems: isMobile ? "" : "center",
            alignSelf: "stretch",
            flexDirection: isMobile ? "column" : "",
            gap: isMobile ? "12px" : "",
            justifyContent: isMobile ? "" : "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              flex: "1 0 0",
            }}
          >
            <Typography
              sx={{
                color: isDarkTheme
                  ? darkTheme.textColorLayer2
                  : lightTheme.textColorLayer2,
                fontFeatureSettings: "'liga' off, 'clig' off",
                fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
                fontSize: "var(--Font-Size-H5, 24px)",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "var(--Line-Height-H5, 32px)",
              }}
            >
              Apps
            </Typography>
          </Box>
          <CustomSearch handleSearch={handleSearch} />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          padding: "var(--Spacing-spacing-8, 8px)",
          paddingBottom: "16px",
          alignItems: "center",
          alignSelf: "stretch",
          justifyContent: isMobile ? "" : "flex-end",
          flexDirection: isMedium ? "column" : "",
          gap: isMedium ? "14px" : "16px",
          background: isDarkTheme
            ? darkTheme.backgroundColorLayer1
            : "var(--Tokens-Background-Layer-01, #FBFCFE)",
          boxShadow: "0px -2px 0px 0px #D7E5F8 inset",
        }}
      >
        <Button
          style={{ ...commonButtonStyle, width: isMedium ? "100%" : "" }}
          onClick={handleOpenModal}
        >
          <Typography sx={commonTextStyle}>Add apps</Typography>
          {/* <SaveAltIcon sx={{ fill: "white" }} /> */}
        </Button>
      </Box>
      <AppTable searchText={searchText} mobileLoading={mobileLoading} />
      {open && <AdminAppModal open={open} setOpen={setOpen} />}
    </CommonLayout>
  );
}
 
